type Props = React.SVGProps<SVGSVGElement> & {
  className?: string;
};

export default function MessagerieIcon({ className, ...props }: Props) {
  return (
    <svg
      width="28px"
      height="29px"
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.75977 6.16343C2.75977 4.91386 3.77274 3.90088 5.02232 3.90088H22.978C24.2276 3.90088 25.2406 4.91386 25.2406 6.16343V17.7064C25.2406 18.9559 24.2276 19.9689 22.978 19.9689H14.9802V23.1391H19.1304C19.6716 23.1391 20.1104 23.5779 20.1104 24.1191C20.1104 24.6604 19.6716 25.0991 19.1304 25.0991H8.86996C8.32873 25.0991 7.88996 24.6604 7.88996 24.1191C7.88996 23.5779 8.32872 23.1391 8.86996 23.1391H13.0202V19.9689H5.02232C3.77274 19.9689 2.75977 18.9559 2.75977 17.7064V6.16343ZM17.9882 10.9998C18.6443 10.3437 18.6443 9.27999 17.9882 8.62391C17.3321 7.96782 16.2684 7.96782 15.6123 8.62391L12.8803 11.356L12.3882 10.8639C11.7321 10.2078 10.6684 10.2078 10.0123 10.8639C9.35621 11.52 9.35622 12.5837 10.0123 13.2398L11.6923 14.9198C12.3484 15.5759 13.4121 15.5759 14.0682 14.9198L17.9882 10.9998Z"
        fill="currentcolor"
      />
    </svg>
  );
}
